import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "__Reports pl-1 pr-1 mx-auto max-w-(--breakpoint-4xl)" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-2 md:gap-2" }
const _hoisted_3 = { class: "col-span-3" }
const _hoisted_4 = { class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800 mb-2" }
const _hoisted_5 = { class: "flex justify-between gap-2 mb-4" }
const _hoisted_6 = { class: "flex justify-between mb-4" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800" }
const _hoisted_9 = { class: "col-span-9 space-y-2 p-4 rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] scroll-container" }
const _hoisted_10 = { class: "grid grid-cols-9 gap-3" }
const _hoisted_11 = { class: "col-span-6" }
const _hoisted_12 = { class: "col-span-3" }
const _hoisted_13 = { class: "grid grid-cols-10 gap-2" }
const _hoisted_14 = { class: "grid grid-cols-5 gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")
  const _component_v_select = _resolveComponent("v-select")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" <Error_zone :error_zone=\"ErrorZone.application\"></Error_zone> "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_basic_button, {
              onClick: _cache[0] || (_cache[0] = $event => ($setup.router.push('/'))),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "fa-solid fa-home" }, null, -1 /* CACHED */),
                _createTextVNode(" Home ")
              ])),
              _: 1 /* STABLE */,
              __: [18]
            }, 8 /* PROPS */, ["size"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_basic_button, {
              onClick: _cache[1] || (_cache[1] = $event => ($setup.router.push('/settings'))),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "fa-solid fa-gear" }, null, -1 /* CACHED */),
                _createTextVNode(" Settings ")
              ])),
              _: 1 /* STABLE */,
              __: [19]
            }, 8 /* PROPS */, ["size"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_basic_button, {
              onClick: _cache[2] || (_cache[2] = $event => ($setup.router.push('/users'))),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [
                _createElementVNode("i", { class: "fa-solid fa-users" }, null, -1 /* CACHED */),
                _createTextVNode(" Users ")
              ])),
              _: 1 /* STABLE */,
              __: [20]
            }, 8 /* PROPS */, ["size"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Part Name ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.search_text) = $event)),
              placeholder: "Part Name...",
              class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.search_text]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Project Number ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.project_id) = $event)),
              placeholder: "Project Number...",
              class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.project_id]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[23] || (_cache[23] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Vendor ", -1 /* CACHED */)),
            _createVNode(_component_v_select, {
              modelValue: $setup.vendor,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.vendor) = $event)),
              placeholder: "Vendor...",
              class: "vendor_options",
              options: $setup.com_vendor_options
            }, null, 8 /* PROPS */, ["modelValue", "options"])
          ]),
          _createElementVNode("div", null, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Customer ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.customer) = $event)),
              placeholder: "Customer...",
              class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.customer]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Project Manager ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.project_manager) = $event)),
              placeholder: "Project Manager...",
              class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.project_manager]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Invoice Number ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.invoice_NaN) = $event)),
              placeholder: "Invoice Number...",
              class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.invoice_NaN]
            ])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Registered Part Name ", -1 /* CACHED */)),
            _createVNode(_component_v_select, {
              options: $setup.search_registered_parts_options,
              modelValue: $setup.search_registered_parts_value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.search_registered_parts_value) = $event)),
              onSearch: $setup.search_registered_part_names,
              multiple: true,
              label: "name"
            }, null, 8 /* PROPS */, ["options", "modelValue"])
          ], 512 /* NEED_PATCH */), [
            [_vShow, !$setup.is_searching_registered_parts]
          ]),
          _createElementVNode("div", null, [
            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Invoice Date After ", -1 /* CACHED */)),
            _createVNode($setup["VueDatePicker"], {
              modelValue: $setup.invoice_date_after,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.invoice_date_after) = $event)),
              "auto-apply": true
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Invoice Date Before ", -1 /* CACHED */)),
            _createVNode($setup["VueDatePicker"], {
              modelValue: $setup.invoice_date_before,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.invoice_date_before) = $event)),
              "auto-apply": true
            }, null, 8 /* PROPS */, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_select, {
              modelValue: $setup.com_is_searching_registered_parts,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.com_is_searching_registered_parts) = $event)),
              options: $setup.is_searching_registered_parts_options
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_basic_button, {
              size: $setup.Size.small,
              onClick: _cache[13] || (_cache[13] = $event => ($setup.download_csv()))
            }, {
              default: _withCtx(() => _cache[30] || (_cache[30] = [
                _createElementVNode("i", { class: "fa-regular fa-file-lines" }, null, -1 /* CACHED */),
                _createTextVNode("Download CSV")
              ])),
              _: 1 /* STABLE */,
              __: [30]
            }, 8 /* PROPS */, ["size"])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _cache[31] || (_cache[31] = _createStaticVNode("<div><strong>Project Number</strong></div><div><strong>Invoice Number</strong></div><div><strong>Invoice Date</strong></div><div><strong>Customer</strong></div><div><strong>Vendor</strong></div><div><strong>Project Manager</strong></div><div><strong>Part Name</strong></div><div><strong>Quantity</strong></div><div><strong>Unit Price</strong></div><div><strong>Line Price</strong></div>", 10)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invoice_list_items?.results, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.project_id), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.invoice_NaN), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString($setup.display_date(item.invoice_date)), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.customer), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.vendor), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.project_manager), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.part_name), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.quantity), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.price_per_unit), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, _toDisplayString(item.line_item_total), 1 /* TEXT */))
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vShow, !$setup.is_searching_registered_parts]
        ]),
        _withDirectives(_createVNode($setup["Paginator"], {
          "total-items": $setup.invoice_list_items?.total_count,
          "current-page": $setup.current_page_invoice_line_items,
          "page-size": $setup.page_size_invoice_line_items,
          "onUpdate:pageSize": _cache[14] || (_cache[14] = $event => ($setup.page_size_invoice_line_items = $event)),
          "onUpdate:currentPage": _cache[15] || (_cache[15] = $event => ($setup.current_page_invoice_line_items = $event))
        }, null, 8 /* PROPS */, ["total-items", "current-page", "page-size"]), [
          [_vShow, !$setup.is_searching_registered_parts]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_14, [
          _cache[32] || (_cache[32] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, "Part Name")
          ], -1 /* CACHED */)),
          _cache[33] || (_cache[33] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, "Total Quantity")
          ], -1 /* CACHED */)),
          _cache[34] || (_cache[34] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, "Avg. Price per Unit")
          ], -1 /* CACHED */)),
          _cache[35] || (_cache[35] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, "Avg. Line item total")
          ], -1 /* CACHED */)),
          _cache[36] || (_cache[36] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, "Sum Line item total")
          ], -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.registered_products?.results, (registered_product) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (_openBlock(), _createElementBlock("div", {
                key: registered_product.part_name
              }, _toDisplayString(registered_product.part_name), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: registered_product.part_name
              }, _toDisplayString(registered_product.quantity), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: registered_product.part_name
              }, _toDisplayString($setup.display_currency(registered_product.avg_price_per_unit)), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: registered_product.part_name
              }, _toDisplayString($setup.display_currency(registered_product.avg_line_item_total)), 1 /* TEXT */)),
              (_openBlock(), _createElementBlock("div", {
                key: registered_product.part_name
              }, _toDisplayString($setup.display_currency(registered_product.sum_line_item_total)), 1 /* TEXT */))
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.is_searching_registered_parts]
        ]),
        _withDirectives(_createVNode($setup["Paginator"], {
          "total-items": $setup.registered_products?.total_count,
          "current-page": $setup.current_page_parts,
          "page-size": $setup.page_size_parts,
          "onUpdate:pageSize": _cache[16] || (_cache[16] = $event => ($setup.page_size_parts = $event)),
          "onUpdate:currentPage": _cache[17] || (_cache[17] = $event => ($setup.current_page_parts = $event))
        }, null, 8 /* PROPS */, ["total-items", "current-page", "page-size"]), [
          [_vShow, $setup.is_searching_registered_parts]
        ])
      ])
    ])
  ]))
}